/**
 * Tekst prawny z endpointu health-radar (EN): zamiana średnika przed „not a medical…” na przecinek.
 * @param {string} disclaimer
 * @param {string} [responseLanguage] — np. `data.language` lub język zapytania `en` | `pl`
 */
export function formatHealthRadarDisclaimer(disclaimer, responseLanguage) {
  if (typeof disclaimer !== 'string') return '';
  const s = disclaimer.trim();
  if (!s) return '';
  const lang =
    typeof responseLanguage === 'string' ? responseLanguage.toLowerCase().split(/[-_]/)[0] : '';
  if (lang !== 'en') return s;
  return s.replace(/;\s*not a medical device diagnosis/gi, ', not a medical device diagnosis');
}
